const en_whs_returnsup = {
    "": "return supplier",
    detail: "return supplier detail",
}

export default en_whs_returnsup;